import {
	AppBar,
	Button,
	Grid2 as Grid,
	Toolbar,
	Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
	BLACK,
	YELLOW_CANARY,
} from "../../../../../controls/shared/constants/colors";
import { ProcessWithoutDeliveryTicket } from "../../../models/ProcessWithoutDeliveryTicket";

interface DeliveryTicketAlertProps {
	processes: ProcessWithoutDeliveryTicket[];
	onDeclareClick: (processId: number) => void;
}

export const DeliveryTicketAlert = ({
	processes,
	onDeclareClick,
}: DeliveryTicketAlertProps) => {
	const navigate = useNavigate();

	const handleDeclareNow = () => {
		if (processes.length === 1) {
			// Single process: Call onDeclareClick which handles routing/modal
			onDeclareClick(processes[0].ProcessId);
		} else {
			// Multiple processes: Navigate to Production Management page with modal open flag
			const firstProcess = processes[0];
			navigate(
				`/production-management/${firstProcess.ShiftId}?processId=${firstProcess.ProcessId}&openModal=deliveryTicket`,
			);
		}
	};

	return (
		<AppBar
			position="static"
			style={{ backgroundColor: YELLOW_CANARY }}
			key={`delivery-ticket-alert-${processes.length}`}
		>
			<Toolbar>
				<Grid
					container
					justifyContent="flex-start"
					alignItems="center"
					spacing={2}
				>
					<Grid size={{ xs: 12, md: "auto" }}>
						<Typography variant="h6" style={{ color: BLACK }}>
							You have {processes.length} heat
							{processes.length > 1 ? "s" : ""} without DELIVERY TICKET declared
						</Typography>
					</Grid>
					<Grid size={{ xs: 12, md: "auto" }}>
						<Button
							onClick={handleDeclareNow}
							variant="contained"
							color="primary"
							size="large"
						>
							Declare Now!
						</Button>
					</Grid>
				</Grid>
			</Toolbar>
		</AppBar>
	);
};
